import { render, staticRenderFns } from "./Store.vue?vue&type=template&id=3748de9b"
import script from "./Store.vue?vue&type=script&lang=ts"
export * from "./Store.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports